module.exports = __webpack_public_path__ + "static/blend-a8fc1bca5375f4161e7ce585ef592d67.mp4";